import React, { Component } from 'react'
import {connect} from 'react-redux'
import Config from './PayrollConfig'

class PayrollTableHeader extends Component {

  constructor(props) {
    super(props)
    this.state = {}
  }

  renderHeaderText(text, key) {
    return (
      <div
        key={text}
        style={styles.headerText(key)}>
        {text}
      </div>
    )
  }

  render() {
    const views = []
    const viewHeaders = this.props.headers.slice()
    viewHeaders.unshift('date') //date should always be first
    viewHeaders.forEach(header => {
      let label = header, key
      if (Config[header]){
        label = Config[header]['label']
        key = Config[header]['key']
      }
      views.push(this.renderHeaderText(label, key))
    })

    return (
      <div
        key='header'
        style={{ display: 'flex', flexDirection: 'row',
          height: 32, paddingLeft: 16, paddingRight: 16, paddingBottom: 8,
          alignItems: 'flex-end', boxShadow: 'inset 0 -2px 0 0 #c3deeb' }}>
        {views}
      </div>
    )
  }
}

function mapStateToProps(state){
  const args = state.reports.headers['PAYROLL_HEADERS'];
  if (args && args.columnHeaders){
    return { headers: args.columnHeaders };
  } else {
    return { headers: [] };
  }
}

const styles = {
  
  headerText: (key) => ({
    display: 'flex',
    justifyContent: key === 'signature' ? 'center' : 'flex-start',
    flexGrow: 1,
    width: 0,
    fontSize: 14,
    fontWeight: '400',
    letterSpacing: 0.6,
    color: '#356992',
  })

}

export default connect(mapStateToProps)(PayrollTableHeader)



// WEBPACK FOOTER //
// ./src/reports/payroll/PayrollTableHeader.js